var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMarkedIcon = function SvgMarkedIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.704 0 0 4.928 0 11C0 17.072 4.704 22 10.5 22C16.296 22 21 17.072 21 11C21 4.928 16.296 0 10.5 0ZM10.5 19.8C5.8695 19.8 2.1 15.851 2.1 11C2.1 6.149 5.8695 2.2 10.5 2.2C15.1305 2.2 18.9 6.149 18.9 11C18.9 15.851 15.1305 19.8 10.5 19.8ZM15.3195 6.138L8.4 13.387L5.6805 10.549L4.2 12.1L8.4 16.5L16.8 7.7L15.3195 6.138Z",
    fill: "#7E8A2E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMarkedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "marked-icon.188fb324b0350b78db313458693dc859.svg";